exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dateRange-1NxZU{-webkit-box-align:center;-ms-flex-align:center;align-items:center;display:-webkit-box;display:-ms-flexbox;display:flex}.dateRange-1NxZU>*:first-child,.dateRange-1NxZU>*:last-child{-webkit-box-flex:1;-ms-flex:auto;flex:auto;margin-bottom:0}.dateRange-1NxZU .divider-1VYuw{margin:0 14px}", ""]);

// exports
exports.locals = {
	"dateRange": "dateRange-1NxZU",
	"divider": "divider-1VYuw"
};